import React from 'react';
import { MainImageComponent } from './MainImage.styles.js';
import Image from 'components/_common/image';

const MainImage = props => {
  return (
    <MainImageComponent>
      <Image {...props} />
    </MainImageComponent>
  );
};

export default MainImage;
